import { IS_WEB } from 'constants/platform'
import React from 'react'

import { ActionIcon } from 'partials/PostCard/subcomponents'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Image } from 'widgets/Image'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useMaxWidth } from 'hooks/useMaxWidth'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

import { Post } from 'types/post'

type ActionRowProps = {
  data: Post | undefined
  position?: number
  isActionPicker?: boolean
  isSelected?: boolean
  onActionPress?: () => void
}

export const ProgramActionRow = ({
  data,
  position,
  isActionPicker = false,
  isSelected = false,
  onActionPress,
}: ActionRowProps) => {
  const { width: maxWidth } = useMaxWidth()

  return (
    <Box flexDirection='row' margin={{ horizontal: 'md', bottom: 'smd' }}>
      <Box
        width={maxWidth * (isActionPicker ? 0.2 : 0.28)}
        height={maxWidth * (isActionPicker ? 0.28 : 0.35)}
        justifyContent='center'
        align='center'
        borderRadius='sm'
        backgroundColor='v2lightGrey'
        style={commonStyles.overflowHidden}
      >
        <Image
          resizeMode='cover'
          style={commonStyles.fullSize}
          source={
            IS_WEB
              ? data?.thumbnail?.url || defaultPostThumbnailUrl
              : data?.thumbnail || defaultPostThumbnailUrl
          }
        />
      </Box>
      <Box flex={1} margin={{ left: 'md' }}>
        {!isActionPicker && (
          <Box height={30} flexDirection='row' align='center' justifyContent='space-between'>
            <Text color='greyDark'>Action {position ?? ''}</Text>
            <ActionIcon
              icon='more-horizontal'
              action={onActionPress}
              color='greyDark'
              iconSize={24}
            />
          </Box>
        )}

        <Box
          flex={1}
          padding={{ top: isActionPicker ? 'smd' : 'sm', right: isActionPicker ? 35 : undefined }}
        >
          <Text color='black' bold numberOfLines={1}>
            {data?.title ?? ''}
          </Text>
          <Text
            color={data?.description?.length ? 'black' : 'v2midGrey'}
            fontSize='sm'
            numberOfLines={3}
          >
            {data?.description?.length ? data?.description : 'No description to show'}
          </Text>
        </Box>

        {isActionPicker && (
          <Box position='absolute' height='100%' width={35} style={{ right: 0 }}>
            <Pressable style={commonStyles.fullSize} onPress={onActionPress}>
              <Box width='100%' height={maxWidth * 0.28} align='flex-end' justifyContent='center'>
                <Box
                  width={22}
                  height={22}
                  borderRadius='lg'
                  align='center'
                  justifyContent='center'
                  padding={{ top: 'xxs' }}
                  border={{ width: 1, color: isSelected ? 'v2primary' : 'greyDark' }}
                  backgroundColor={isSelected ? 'v2primary' : 'white'}
                >
                  {isSelected && <Icon size={18} name='check' color='white' />}
                </Box>
              </Box>
            </Pressable>
          </Box>
        )}
      </Box>
    </Box>
  )
}
